<button
  type="button"
  [class]="rootClasses"
  [disabled]="disabled"
  [attr.aria-pressed]="selected"
  (click)="onActivate()"
  (keydown)="onKeydown($event)"
>
  <div class="munily-button-card__head">
    <span class="munily-button-card__title">{{ title }}</span>
    <app-info-chip
      *ngIf="hasChip"
      [label]="chip!.label"
      [color]="chip!.color || defaultChipColor"
      [type]="chip!.type || defaultChipType"
      [size]="chip!.size || defaultChipSize"
      [shape]="chip!.shape || defaultChipShape"
    ></app-info-chip>
  </div>
  <p *ngIf="hasDescription" class="munily-button-card__description">
    {{ description }}
  </p>
</button>
